// SemanticUI-free pre-@plone/components
import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { PropTypes } from 'prop-types';
import { defineMessages, injectIntl } from 'react-intl';

import Icon from '@plone/volto/components/theme/Icon/Icon';
import zoomSVG from '@plone/volto/icons/zoom.svg';

const messages = defineMessages({
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  searchTerm: {
    id: 'Search term',
    defaultMessage: 'Search term',
  },
});

/**
 * SearchWidget component class.
 * @class SearchWidget
 * @extends Component
 */
class SearchWidget extends Component {
  /**
   * Property types.
   * @property {Object} propTypes Property types.
   * @static
   */
  static propTypes = {
    pathname: PropTypes.string,
  };

  /**
   * Constructor
   * @method constructor
   * @param {Object} props Component properties
   * @constructs WysiwygEditor
   */
  constructor(props) {
    super(props);
    this.onChangeText = this.onChangeText.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
    this.state = {
      text: '',
    };
  }

  /**
   * On change text
   * @method onChangeText
   * @param {object} event Event object.
   * @param {string} value Text value.
   * @returns {undefined}
   */
  onChangeText(event) {
    this.setState({
      text: event.target.value,
    });
  }

  /**
   * Submit handler
   * @method onSubmit
   * @param {event} event Event object.
   * @returns {undefined}
   */
  onSubmit(event) {
    const path =
      this.props.pathname?.length > 0
        ? `&path=${encodeURIComponent(this.props.pathname)}`
        : '';
    this.props.history.push(
      `/search?SearchableText=${encodeURIComponent(this.state.text)}${path}`,
    );
    event.preventDefault();
  }

  searchbar = React.createRef();

  /**
   * Render method.
   * @method render
   * @returns {string} Markup for the component.
   */
  render() {
    return (
      <div ref={this.searchbar} className="search-bar">
        <form action="/search" onSubmit={this.onSubmit}>
          <div className="searchbox">
            <input
              aria-label={this.props.intl.formatMessage(messages.search)}
              onChange={(e) => this.onChangeText(e)}
              name="SearchableText"
              value={this.state.text}
              autoComplete="off"
              placeholder={this.props.intl.formatMessage(messages.searchTerm)}
              title={this.props.intl.formatMessage(messages.search)}
              ref={(input) => {
                this.refInput = input;
              }}
            />
            <button aria-label={this.props.intl.formatMessage(messages.search)}>
              <Icon name={zoomSVG} size="18px" />
            </button>
          </div>
        </form>
      </div>
    );
  }
}

export default compose(withRouter, injectIntl)(SearchWidget);
